import { render, staticRenderFns } from "./goodd.vue?vue&type=template&id=bdf56e44&scoped=true&"
import script from "./goodd.vue?vue&type=script&lang=js&"
export * from "./goodd.vue?vue&type=script&lang=js&"
import style0 from "./goodd.vue?vue&type=style&index=0&id=bdf56e44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf56e44",
  null
  
)

export default component.exports